import { Component, OnInit, Input } from '@angular/core';
import { ApiService } from '../../../shared/api.service';
import { Router } from '@angular/router';
import { EventSendeurService } from '../../../shared/event-sendeur.service';
import { NbToastrService, NbDialogRef } from '@nebular/theme';
import { Categorie } from '../../../shared/data/categorie';
import { plainToClass } from 'class-transformer';
import { Faculte } from '../../../shared/data/faculte';

@Component({
  selector: 'ngx-edit-faculte',
  templateUrl: './edit-faculte.component.html',
  styleUrls: ['./edit-faculte.component.scss']
})
export class EditFaculteComponent implements OnInit {
  @Input() id: number;
  @Input() ecole: number;
  /* nome;
  desc;
  cate:any = []; */
  facult = new Faculte;
  hideLoader =true;
  hideButon =false;
  // pr;

  titre = 'option';

 

  categories: any[];

  constructor(protected dialogRef: NbDialogRef<EditFaculteComponent>,private apiService:ApiService, private router:Router,private sendeurService:EventSendeurService, public toastr: NbToastrService) {
  
    /* if( this.id !== 0 )
    this.getCategories(); */

    

  }

  ngOnInit() {

    if(this.ecole !== undefined)
    this.facult.ecole = this.ecole;

    if(this.id !== 0)
    this.getOneFaculte();
   
  }

  cancel(){
    this.dialogRef.close();
    
    
  }

  close(){
    this.dialogRef.close();
    
    
  }

  

  updateFacult(){

    if( this.id !== 0 ) {

      this.hideButon= true;
      this.hideLoader = false;
      this.apiService.updateFaculteProvider(this.facult).subscribe((data: Faculte) =>{
        console.log(data);
        this.toastr.success("mise à jour réussie","success");
        this.dialogRef.close();
        /* this.sendeurService.sendCategoryEvent(7); */
        this.sendeurService.sendFacultEvent(data);

      },(err) =>{
        console.log(err);
        this.toastr.danger("echec de mise à jour réussie, le nom de cette category existe peut être déjà");
        this.hideButon= false;
        this.hideLoader = true;
        if(err.error.code ===401){
          localStorage.clear();
          window.location.reload();
          let link2 = ['/login'];
          this.router.navigate(link2);
        }

        if(err.error.code ===500){
        
            this.toastr.danger("Le serveur est actuellement indisponible, veuillez patienter ou actualiser la page");
        }
    
      })

    } else {


      this.hideLoader = false;
      this.hideButon = true;
      

      this.apiService.addFaculteProvider(this.facult).subscribe((data: Faculte) =>{
        console.log(data);
        this.toastr.success("Faculté crée avec success");
        this.dialogRef.close();
        this.sendeurService.sendFacultEvent(data);
        /* this.sendeurService.sendCategoryEvent(5); */
      },(err) =>{
        this.hideLoader = true;
        this.hideButon = false;
        this.toastr.danger("Il se peut qu'une faculte portant le meme nom existe déjà","erreur");
        console.log(err);
      
        if(err.error.code ===401){
          localStorage.clear();
          window.location.reload();
          let link2 = ['/login'];
          this.router.navigate(link2);
        }

        if(err.error.code ===500){
          this.toastr.danger("Le serveur est actuellement indisponible, veuillez patienter ou actualiser la page","echec");
        }
    
    })



    }
    
  }

  getOneFaculte(){

    this.apiService.getOneFaculteProvider(this.id).subscribe(data =>{

      this.facult = plainToClass(Faculte, data as object);

    },(err) =>{
      

      if(err.error.code ===401){
        localStorage.clear();
        window.location.reload();
        let link2 = ['/login'];
        this.router.navigate(link2);
      }


      if(err.error.code ===500){
        this.toastr.danger("Le serveur est actuellement indisponible, veuillez patienter ou actualiser la page");
      }

    })

  }




}
